module.exports = __webpack_public_path__ + "static/img/klp1360-663-37084rd.b83e9e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/klp1360-663-37084rd.jpg
// module id = 12W7
// module chunks = 0